/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ActionType {
    EMAIL = 'Email',
    SMS = 'SMS',
    CALL = 'Call',
    NOTIFICATION = 'Notification',
    CHANGE_WORKFLOW_STATUS = 'ChangeWorkflowStatus',
    HOUSING_CUSTOM = 'HousingCustom',
}
